'use strict';

module.exports = '3.2.2';
